export default __webpack_public_path__ + "static/media/Basic-black.2d28d75c.png";